export enum ContactByTypes {
  SMS = 'sms',
  EMAIL = 'email',
  PHONE = 'phone',
}
